import { render } from "./product-meta-image.vue?vue&type=template&id=7bbfdac6&scoped=true"
import script from "./product-meta-image.vue?vue&type=script&lang=js"
export * from "./product-meta-image.vue?vue&type=script&lang=js"

import "./product-meta-image.vue?vue&type=style&index=0&id=7bbfdac6&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bbfdac6"]])

export default __exports__